<template>
  <div>
    <el-pagination
      class="pagination-right"
      v-model::current-page="currentPage"
      :page-sizes="pageSizes"
      v-model:page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import requestUtil from "@/util/request";

const props = defineProps({
  apiUrl: { type: String, required: true },
  searchParams: { type: Object, required: true }
});

// 响应式数据
const currentPage = ref(1);
const pageSizes = ref([20, 50, 100]);
const pageSize = ref(100);
const total = ref(0);
const tableData = ref([]);

const queryForm = ref({
  pageNum: 1,
  pageSize: 100
});

const combinedQueryParams = ref({});
const emit = defineEmits(['data-sent']);

// 👇 增加 watch 监听 pageSize 变化
watch(pageSize, (newVal, oldVal) => {
  console.log('[诊断] pageSize 已更新:', { oldVal, newVal, type: typeof newVal });
}, { immediate: true });

// 👇 增加 watch 监听 currentPage 变化
watch(currentPage, (newVal, oldVal) => {
  console.log('[诊断] currentPage 已更新:', { oldVal, newVal });
});

// 处理每页条数变化
const handleSizeChange = async (val) => {
  console.log('[事件] size-change 触发，用户选择:', val, typeof val);
  pageSize.value = val;
  queryForm.value.pageNum = 1;
  queryForm.value.pageSize = val;
  await fetchData();
};

// 处理页码变化
const handleCurrentChange = async (val) => {
  console.log('[事件] current-change 触发，当前页:', val);
  currentPage.value = val;
  queryForm.value.pageNum = val;
  await fetchData();
};

// 获取数据
const fetchData = async () => {
  console.log('--- 开始请求分页数据 ---');
  console.log('[fetchData] props.apiUrl:', props.apiUrl);
  console.log('[fetchData] props.searchParams:', props.searchParams);
  console.log('[fetchData] queryForm 当前值:', queryForm.value);

  combinedQueryParams.value = {
    ...props.searchParams,
    ...queryForm.value
  };

  console.log('[fetchData] 最终请求参数 combinedQueryParams:', combinedQueryParams.value);

  try {
    const response = await requestUtil.post(props.apiUrl, combinedQueryParams.value);
    console.log('[API 响应] response.data:', response.data);

    if (response.data && Array.isArray(response.data.dataList)) {
      tableData.value = response.data.dataList;
      total.value = response.data.total || 0;
      console.log(`[API 成功] 返回 ${tableData.value.length} 条数据，总数: ${total.value}`);
    } else {
      console.warn('[API 警告] 返回数据格式异常:', response.data);
      tableData.value = [];
      total.value = 0;
    }

    emit('data-sent', tableData.value);
  } catch (error) {
    console.error('[API 错误] 请求失败:', error);
    total.value = 0;
    tableData.value = [];
  }
  console.log('--- 请求结束 ---');
};

// 组件挂载时初始化
onMounted(() => {
  console.log('=== onMounted 执行 ===');
  console.log('初始 queryForm:', queryForm.value);
  console.log('初始 pageSize:', pageSize.value, typeof pageSize.value);
  console.log('初始 currentPage:', currentPage.value);

  // ✅ 确保同步所有值
  queryForm.value.pageSize = 100;
  queryForm.value.pageNum = 1;
  pageSize.value = 100;
  currentPage.value = 1;

  console.log('更新后 queryForm:', queryForm.value);
  console.log('更新后 pageSize:', pageSize.value, typeof pageSize.value);
  console.log('pageSizes 选项:', pageSizes.value);

  // 👉 确保传给后端的是 number
  if (typeof pageSize.value !== 'number') {
    console.error('❌ pageSize 不是 number 类型！当前类型:', typeof pageSize.value);
  }

  fetchData();
});

defineExpose({ fetchData });
</script>

<style>
.pagination-right {
  text-align: right;
  margin-top: 10px;
}
</style>